import { render, staticRenderFns } from "./ModulesContent.vue?vue&type=template&id=81df9cfc&"
import script from "./ModulesContent.vue?vue&type=script&lang=js&"
export * from "./ModulesContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports